import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {getAdminEmpresa, getGestorEmpresa, getGestorOperacoes, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import buscarPrecosRota from '../../actions/preco/buscarPrecosRota';
import Conexao from './Conexao';
import buscarUltimosHistoricosRota from '../../actions/rota/buscarUltimosHisotirocosRota';
import iconAudoria from '../../img/auditoria.png';

export class Rota extends React.Component {
    selecionarRota() {
        this.props.selecionarOrigem(this.props.rota.cidadeOrigem);
        this.props.selecionarDestino(this.props.rota.cidadeDestino);
        this.props.selecionarRota(this.props.rota);
    }

    selecionarConexao() {
        this.props.selecionarOrigem(null);
        this.props.selecionarDestino(null);
        this.props.selecionarConexao(null);
        this.props.selecionarRota(this.props.rota);
    }

    render() {
        const rota = this.props.rota;
        return (
            <React.Fragment>
                <div className="vx-row-item">
                    <div className="vx-row-item-inner vx-row-item-inner--rota">
                        <div className="vx-row-cell">
                            <button className="vx-row-expand-btn" title="Conexões"
                                onClick={() => this.props.alterarExibicaoDetalhamentoRota(rota)}>
                                <span className="material-icons">{rota.exibirDetalhe ? 'expand_less' : 'expand_more'}</span>
                            </button>
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">ID</span>
                            {rota.id || ''}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Prefixo</span>
                            {rota.prefixo || 'Não informado'}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Origem</span>
                            {rota.cidadeOrigem ? rota.cidadeOrigem.nomeComUf : ''}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Destino</span>
                            {rota.cidadeDestino ? rota.cidadeDestino.nomeComUf : ''}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Delimitação</span>
                            {rota.delimitacao || 'Não informado'}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Ações</span>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getAdminEmpresa(this.props.empresaSelecionada.id),
                                getGestorEmpresa(this.props.empresaSelecionada.id),
                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                    <button type="button" className="vx-act-btn vx-act-btn--delete"
                                        title="Excluir rota"
                                        data-toggle="modal"
                                        data-target="#modalConfirmacaoExclusaoRota"
                                        onClick={() => this.props.selecionarRota(rota)}>
                                        <span className="material-icons">delete</span>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--edit"
                                        title="Editar rota"
                                        data-toggle="modal"
                                        data-target="#modalCadastrarRota"
                                        onClick={() => this.selecionarRota()}>
                                        <span className="material-icons">edit</span>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Criar rota de retorno"
                                        data-toggle="modal"
                                        data-target="#modalConfirmacaoCadastroRotaRetorno"
                                        onClick={() => this.props.selecionarRota(rota)}>
                                        <i className="material-icons" style={{ fontSize: 18 }}>&#xe31b;</i>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Visualizar trechos"
                                        data-toggle="modal"
                                        data-target="#modalTrechos"
                                        onClick={() => this.props.selecionarRota(rota)}>
                                        <i className="material-icons" style={{ fontSize: 18 }}>&#xe8d4;</i>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Criar conexão"
                                        data-toggle="modal"
                                        data-target="#modalCadastroConexao"
                                        onClick={() => this.selecionarConexao()}>
                                        <i className="material-icons" style={{ fontSize: 18 }}>&#xe0b3;</i>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Relação de valores da rota"
                                        data-toggle="modal"
                                        data-target="#modalPrecosRota"
                                        onClick={() => {
                                            this.props.buscarPrecosRota(this.props.empresaSelecionada.id, rota.id);
                                            this.props.selecionarRota(rota);
                                        }}>
                                        <span className="material-icons">attach_money</span>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Histórico da rota"
                                        data-toggle="modal"
                                        data-target="#modalHistoricoRota"
                                        onClick={() => {
                                            this.props.selecionarRota(rota);
                                            this.props.buscarUltimosHistoricosRota(rota.id, this.props.empresaSelecionada.id);
                                        }}>
                                        <img src={iconAudoria} alt="Histórico Rota" />
                                    </button>
                                </div>
                            </Autorizacao>
                        </div>
                    </div>
                </div>
                {rota.exibirDetalhe &&
                    <div className="vx-row-detail">
                        <div className="vx-row-detail-title">Conexões</div>
                        {rota.conexoes && rota.conexoes.length
                            ? rota.conexoes.map(conexao => (
                                <Conexao rota={rota} key={conexao.id} conexao={conexao}
                                    preencherCidades={this.props.preencherCidades} />
                            ))
                            : <div className="vx-row-detail-empty">Rota não possui conexões cadastradas</div>
                        }
                    </div>
                }
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada
});

export default connect(mapStateToProps, {
    changeFieldValue,
    alterarExibicaoDetalhamentoRota,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    selecionarConexao,
    buscarPrecosRota,
    buscarUltimosHistoricosRota
})(reduxForm({
    form: 'formularioCadastroRota'
})(Rota))
